import { render, staticRenderFns } from "./LoginTemp.vue?vue&type=template&id=d680e24e&"
import script from "./LoginTemp.vue?vue&type=script&lang=js&"
export * from "./LoginTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports